import PenDetailPage from './PenDetailPage';

export default PenDetailPage;
